const SPECIALIZATIONS = ['Vedic Astrology (Jyotish)', 'Palmistry', 'Vastu Shastra', 'Numerology', 'Kundli Matching']

const REASONS = [
  'Ancestral Vedic lineage passed down through generations of scholarship',
  'Combined palm, kundli and horoscope analysis for a complete reading',
  'Vastu correction guidance for homes, offices and business spaces',
  'Remedies rooted in classical scripture, not generic templates',
]

const ACHIEVEMENTS = [
  { value: '15+', label: 'Years of practice' },
  { value: '10K+', label: 'Sessions held' },
  { value: '4.9/5', label: 'Client rating' },
  { value: '40+', label: 'Countries served' },
]

export default function MaharajAboutSection() {
  return (
    <div className="info-card p-6 sm:p-8 space-y-6">
      <h2 className="text-xl font-cinzel text-[#1C140A]">About Raju Maharaj Ji</h2>

      <p className="text-sm leading-relaxed text-[#5C3A18]">
        With over 15 years of deep Vedic scholarship, Raju Maharaj Ji is the founding astrologer and guiding
        presence of this platform. Trained in classical Jyotish, palmistry and Vastu Shastra, he has guided
        4,800+ verified clients across 40+ countries through matters of career, marriage, health and business —
        earning a 98% success rate and a 4.9/5 client rating along the way. His audiences are limited by invitation
        to ensure every reading receives his complete attention.
      </p>

      <div className="flex flex-wrap gap-2">
        {SPECIALIZATIONS.map((s) => (
          <span key={s} className="pill-toggle">{s}</span>
        ))}
      </div>

      <div className="astro-divider" />

      <div className="grid gap-3 sm:grid-cols-2">
        {REASONS.map((r) => (
          <div key={r} className="flex items-start gap-2.5">
            <svg className="w-4 h-4 mt-0.5 text-secondary shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
            </svg>
            <p className="text-xs leading-relaxed text-[#5C3A18]">{r}</p>
          </div>
        ))}
      </div>

      <div className="astro-divider" />

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {ACHIEVEMENTS.map((a) => (
          <div key={a.label} className="rounded-2xl border border-[#D7C29A]/25 p-4 text-center">
            <p className="text-lg font-cinzel font-bold text-[#C8922A]">{a.value}</p>
            <p className="mt-1 text-[9px] uppercase tracking-[0.2em] text-[#8B7355]">{a.label}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
